import Vue from 'vue';
import Router from 'vue-router';

import Layout from '@/layout';
import store from '@/store';
// import tableRouter from './modules/table';
import { getAccessToken, removeAccessToken, getUserInfo, removeUserInfo } from '@/utils/auth';

Vue.use(Router);

const whiteList = ['/login', '/auth-redirect'];

// 动态菜单路由 需要配置menu属性 方便后台做校验 menu 后台权限控制 ''空字符串校验通过 有值时必须属于后台返回的权限数组才有权限
export const asyncRoutes = [
  {
    path: '/external-link',
    menu: '',
    // alwaysShow: true, // will always show the root menu
    name: 'home',
    meta: {
      title: 'home.page',
      icon: 'lock',
      roles: ['admin', 'editor'], // you can set roles in root nav
    },
    children: [
      {
        path: `${window.location.protocol}//${window.location.host}/`,
        menu: '',
        name: 'homepage',
        meta: {
          title: 'home.page',
          icon: 'dashboard',
          //   affix: true,
        },
      },
    ],
  },
  {
    path: '/',
    component: Layout,
    menu: '',
    redirect: '/redirect/homepage',
  },
  {
    path: '/advisor',
    component: Layout,
    menu: 'advisor/list',
    redirect: '/advisor/list',
    // alwaysShow: true, // will always show the root menu
    name: 'system',
    meta: {
      title: 'advisor.manage',
      icon: 'lock',
      roles: ['admin', 'editor'], // you can set roles in root nav
    },
    children: [
      {
        path: 'list',
        menu: 'advisor/list',
        component: () => import('@/views/advisor/list'),
        name: 'advisorlist',
        meta: {
          title: 'advisor.list',
          icon: 'dashboard',
        },
      },
      {
        path: 'managerlist',
        menu: 'advisor/managerlist',
        component: () => import('@/views/advisor/managerlist'),
        name: 'advisormanagerlist',
        meta: {
          title: 'advisor.managerlist',
          icon: 'dashboard',
        },
      },
      {
        path: 'edit/:id',
        menu: 'advisor/list',
        component: () => import('@/views/advisor/edit'),
        name: 'advisordata',
        hidden: true,
        meta: {
          title: 'advisor.edit',
          icon: 'dashboard',
        },
      },
      {
        path: 'detail/:id',
        menu: 'advisor/list',
        component: () => import('@/views/advisor/detail'),
        name: 'advisordetaildata',
        hidden: true,
        meta: {
          title: 'advisor.detail',
          icon: 'dashboard',
        },
      },
      {
        path: 'socialsecuritylist/:id',
        menu: 'advisor/socialsecuritylist',
        component: () => import('@/views/advisor/socialsecuritylist'),
        name: 'advisorsocialsecuritylist',
        hidden: true,
        meta: {
          title: 'advisor.socialsecuritylist',
          icon: 'dashboard',
        },
      },
      {
        path: 'managerdetail/:id',
        menu: 'advisor/managerlist',
        component: () => import('@/views/advisor/managerdetail'),
        name: 'advisormanagerdetaildata',
        hidden: true,
        meta: {
          title: 'advisor.managerdetail',
          icon: 'dashboard',
        },
      },
      {
        path: 'recommendationrelationship/:id',
        menu: 'advisor/list',
        component: () => import('@/views/advisor/recommendationrelationship'),
        name: 'advisorrecommendationrelationship',
        hidden: true,
        meta: {
          title: 'advisor.recommendationrelationship',
          icon: 'dashboard',
        },
      },
      {
        path: 'salesUserStatusChangeLogList',
        menu: 'advisor/salesUserStatusChangeLogList',
        component: () => import('@/views/salesUserLog/salesUserStatusChangeLogList'),
        name: 'salesUserGroupChangesLog',
        meta: {
          title: 'advisor.salesUserStatusChangeLog',
          icon: 'dashboard',
        },
      },
      {
        path: 'salesUserTitleChangesLogList',
        menu: 'advisor/salesUserTitleChangesLogList',
        component: () => import('@/views/salesUserLog/salesUserTitleChangesLogList'),
        name: 'salesUserTitleChangesLog',
        meta: {
          title: 'advisor.salesUserTitleChangesLog',
          icon: 'dashboard',
        },
      },
      {
        path: 'salesUserInfoChangesLogList',
        menu: 'advisor/salesUserInfoChangesLogList',
        component: () => import('@/views/salesUserLog/salesUserInfoChangesLogList'),
        name: 'salesUserInfoChangesLog',
        meta: {
          title: 'advisor.salesUserInfoChangesLog',
          icon: 'dashboard',
        },
      },
      {
        path: 'salesUserGroupChangesLogList',
        menu: 'advisor/salesUserGroupChangesLogList',
        component: () => import('@/views/salesUserLog/salesUserGroupChangesLogList'),
        name: 'salesUserGroupChangesLog',
        meta: {
          title: 'advisor.salesUserGroupChangesLog',
          icon: 'dashboard',
        },
      },
      {
        path: 'promotionlist',
        menu: 'advisor/promotionlist',
        component: () => import('@/views/advisorinduction/promotionlist'),
        name: 'promotionlist',
        meta: {
          title: 'advisor.promotionlist',
          icon: 'dashboard',
        },
      },
      {
        path: 'recommendedtreesnapshot/:id',
        menu: 'advisor/promotionlist',
        component: () => import('@/views/advisorinduction/recommendedtreesnapshot'),
        name: 'recommendedtreesnapshot',
        hidden: true,
        meta: {
          title: 'advisor.recommendedtreesnapshot',
          icon: 'dashboard',
        },
      },
      {
        path: 'mothercaptainchainsnapshot/:id',
        menu: 'advisor/promotionlist',
        component: () => import('@/views/advisorinduction/mothercaptainchainsnapshot'),
        name: 'mothercaptainchainsnapshot',
        hidden: true,
        meta: {
          title: 'advisor.mothercaptainchainsnapshot',
          icon: 'dashboard',
        },
      },
    ],
  },
  {
    path: '/advisorinduction',
    component: Layout,
    menu: 'advisorinduction/list',
    redirect: '/advisorinduction/list',
    // alwaysShow: true, // will always show the root menu
    name: 'system',
    meta: {
      title: 'advisorinduction.manage',
      icon: 'lock',
      roles: ['admin', 'editor'], // you can set roles in root nav
    },
    children: [
      {
        path: 'list',
        menu: 'advisorinduction/list',
        component: () => import('@/views/advisorinduction/list'),
        name: 'advisorinductionlist',
        meta: {
          title: 'advisorinduction.list',
          icon: 'dashboard',
        },
      },
      {
        path: 'storeCandidatelist',
        menu: 'advisorinduction/storeCandidatelist',
        component: () => import('@/views/advisorinduction/storeCandidatelist'),
        name: 'storeCandidatelist',
        meta: {
          title: 'advisorinduction.storeCandidatelist',
          icon: 'dashboard',
        },
      },
      {
        path: 'import',
        menu: 'advisorinduction/import',
        component: () => import('@/views/advisorinduction/import'),
        name: 'advisorinductionimport',
        meta: {
          title: 'advisorinduction.import',
          icon: 'dashboard',
        },
      },
      {
        path: 'blacklist',
        menu: 'advisorinduction/blacklist',
        component: () => import('@/views/ambassador/blacklist'),
        name: 'ambassadorblacklist',
        meta: {
          title: 'advisorinduction.blacklist',
          icon: 'dashboard',
          //   affix: true,
        },
      },
      {
        path: 'blackimport',
        menu: 'advisorinduction/blackimport',
        component: () => import('@/views/ambassador/blackimport'),
        name: 'ambassadorblackimportt',
        meta: {
          title: 'advisorinduction.blackimport',
          icon: 'dashboard',
          //   affix: true,
        },
      },
      {
        path: 'loglist',
        menu: 'advisorinduction/loglist',
        component: () => import('@/views/advisorinduction/loglist'),
        name: 'advisorinductionloglist',
        meta: {
          title: 'advisorinduction.loglist',
          icon: 'dashboard',
        },
      },
      {
        path: 'storeCandidateOperation',
        menu: 'organizationalstructure/storeCandidateOperation',
        component: () => import('@/views/organizationalstructure/storeCandidateOperation'),
        name: 'organizationalstructureStoreCandidateOperation',
        meta: {
          title: 'organizationalstructure.storeCandidateOperation',
          icon: 'dashboard',
        },
      },
      {
        path: 'storeCandidateInfoChangeLog',
        menu: 'organizationalstructure/storeCandidateInfoChangeLog',
        component: () => import('@/views/organizationalstructure/storeCandidateInfoChangeLog'),
        name: 'organizationalstructureStoreCandidateInfoChangeLog',
        meta: {
          title: 'organizationalstructure.storeCandidateInfoChangeLog',
          icon: 'dashboard',
        },
      },
    ],
  },
  {
    path: '/organizationalstructure',
    component: Layout,
    menu: 'organizationalstructure/list',
    redirect: '/organizationalstructure/list',
    // alwaysShow: true, // will always show the root menu
    name: 'system',
    meta: {
      title: 'organizationalstructure.manage',
      icon: 'lock',
      roles: ['admin', 'editor'], // you can set roles in root nav
    },
    children: [
      {
        path: 'list',
        menu: 'organizationalstructure/list',
        component: () => import('@/views/branch/list'),
        name: 'branchlist',
        meta: {
          title: 'branch.list',
          icon: 'dashboard',
          //   affix: true,
        },
      },
      {
        path: 'add/:division',
        menu: 'organizationalstructure/list',
        component: () => import('@/views/branch/add'),
        name: 'branchdata',
        hidden: true,
        meta: {
          title: 'branch.add',
          icon: 'dashboard',
        },
      },
      {
        path: 'edit/:division/:code',
        menu: 'organizationalstructure/edit',
        component: () => import('@/views/branch/edit'),
        name: 'branchdata',
        hidden: true,
        meta: {
          title: 'branch.edit',
          icon: 'dashboard',
        },
      },
      {
        path: 'arealist',
        menu: 'organizationalstructure/arealist',
        component: () => import('@/views/organizationalstructure/arealist'),
        name: 'organizationalstructurearealist',
        meta: {
          title: 'organizationalstructure.arealist',
          icon: 'dashboard',
        },
      },
      {
        path: 'areacreate',
        menu: 'organizationalstructure/areacreate',
        component: () => import('@/views/organizationalstructure/areacreate'),
        name: 'organizationalstructureareacreate',
        hidden: true,
        meta: {
          title: 'organizationalstructure.areacreate',
          icon: 'dashboard',
        },
      },
      {
        path: 'storelist',
        menu: 'organizationalstructure/storelist',
        component: () => import('@/views/organizationalstructure/storelist'),
        name: 'organizationalstructurestorelist',
        meta: {
          title: 'organizationalstructure.storelist',
          icon: 'dashboard',
        },
      },
      {
        path: 'storecreate',
        menu: 'organizationalstructure/storelist',
        component: () => import('@/views/organizationalstructure/storecreate'),
        name: 'organizationalstructurestorecreate',
        hidden: true,
        meta: {
          title: 'organizationalstructure.storecreate',
          icon: 'dashboard',
        },
      },
      {
        path: 'storedetail/:code',
        menu: 'organizationalstructure/storelist',
        component: () => import('@/views/organizationalstructure/storedetail'),
        name: 'organizationalstructurestoredetail',
        hidden: true,
        meta: {
          title: 'organizationalstructure.storedetail',
          icon: 'dashboard',
        },
      },
      {
        path: 'storeedit/:code',
        menu: 'organizationalstructure/storelist',
        component: () => import('@/views/organizationalstructure/storeedit'),
        name: 'organizationalstructurestoreedit',
        hidden: true,
        meta: {
          title: 'organizationalstructure.storeedit',
          icon: 'dashboard',
        },
      },
      {
        path: 'storeInfoChangesLogList',
        menu: 'organizationalstructure/storeInfoChangesLogList',
        component: () => import('@/views/organizationalstructure/storeInfoChangesLogList'),
        name: 'organizationalstructureStoreInfoChangesLog',
        meta: {
          title: 'organizationalstructure.storeInfoChangesLog',
          icon: 'dashboard',
        },
      },
      {
        path: 'storeUserBindingLogList',
        menu: 'organizationalstructure/storeUserBindingLogList',
        component: () => import('@/views/organizationalstructure/storeUserBindingLogList'),
        name: 'organizationalstructureStoreUserBindingLog',
        meta: {
          title: 'organizationalstructure.storeUserBindingLog',
          icon: 'dashboard',
        },
      },
    ],
  },
  {
    path: '/aftersales',
    component: Layout,
    menu: 'aftersales/serviceorderlist',
    redirect: '/aftersales/serviceorderlist',
    // alwaysShow: true, // will always show the root menu
    name: 'aftersales',
    meta: {
      title: 'aftersales.manage',
      icon: 'lock',
      roles: ['admin', 'editor'], // you can set roles in root nav
    },
    children: [
      {
        path: 'serviceorderlist',
        menu: 'aftersales/serviceorderlist',
        component: () => import('@/views/aftersales/serviceorderlist'),
        name: 'serviceorderlist',
        meta: {
          title: 'aftersales.serviceorderlist',
          icon: 'dashboard',
          //   affix: true,
        },
      },
      {
        path: 'serviceorderadminassign/:id',
        menu: 'aftersales/serviceorderlist',
        component: () => import('@/views/aftersales/serviceorderadminassign'),
        name: 'serviceorderadminassign',
        hidden: true,
        meta: {
          title: 'aftersales.serviceorderadminassign',
          icon: 'dashboard',
          //   affix: true,
        },
      },
      {
        path: 'serviceorderfinish/:id',
        menu: 'aftersales/serviceorderlist',
        component: () => import('@/views/aftersales/serviceorderfinish'),
        name: 'serviceorderfinish',
        hidden: true,
        meta: {
          title: 'aftersales.serviceorderfinish',
          icon: 'dashboard',
          //   affix: true,
        },
      },
      {
        path: 'serviceorderimport',
        menu: 'aftersales/serviceorderimport',
        component: () => import('@/views/aftersales/serviceorderimport'),
        name: 'orderimport',
        meta: {
          title: 'aftersales.serviceorderimport',
          icon: 'dashboard',
        },
      },
      {
        path: 'serviceorderoperatelog',
        menu: 'aftersales/serviceorderoperatelog',
        component: () => import('@/views/aftersales/serviceorderoperatelog'),
        name: 'serviceorderoperatelog',
        meta: {
          title: 'aftersales.serviceorderoperatelog',
          icon: 'dashboard',
        },
      },
      // {
      //   path: 'serviceworkflowoperatelog',
      //   menu: 'aftersales/serviceworkflowoperatelog',
      //   component: () => import('@/views/aftersales/serviceworkflowoperatelog'),
      //   name: 'serviceworkflowoperatelog',
      //   meta: {
      //     title: 'aftersales.serviceworkflowoperatelog',
      //     icon: 'dashboard',
      //   },
      // },
    ],
  },
  {
    path: '/paycenter',
    component: Layout,
    menu: 'paycenter/activitylist',
    redirect: '/paycenter/activitylist',
    // alwaysShow: true, // will always show the root menu
    name: 'paycenter',
    meta: {
      title: 'paycenter.manage',
      icon: 'lock',
      roles: ['admin', 'editor'], // you can set roles in root nav
    },
    children: [
      {
        path: 'activitylist',
        menu: 'paycenter/activitylist',
        component: () => import('@/views/paycenter/activitylist'),
        name: 'activitylist',
        meta: {
          title: 'paycenter.activitylist',
          icon: 'dashboard',
        },
      },
      {
        path: 'activitycreate',
        menu: 'paycenter/activitycreate',
        component: () => import('@/views/paycenter/activitycreate'),
        name: 'activitycreate',
        hidden: true,
        meta: {
          title: 'paycenter.activitycreate',
          icon: 'dashboard',
        },
      },
      {
        path: 'activityedit',
        menu: 'paycenter/activityedit',
        component: () => import('@/views/paycenter/activityedit'),
        name: 'activityedit',
        hidden: true,
        meta: {
          title: 'paycenter.activityedit',
          icon: 'dashboard',
        },
      },
      {
        path: 'activityitemslist',
        menu: 'paycenter/activityitemslist',
        component: () => import('@/views/paycenter/activityitemslist'),
        name: 'activityitemslist',
        hidden: true,
        meta: {
          title: 'paycenter.activityitemslist',
          icon: 'dashboard',
        },
      },
      {
        path: 'activityitemcreate',
        menu: 'paycenter/activityitemcreate',
        component: () => import('@/views/paycenter/activityitemcreate'),
        name: 'activityitemcreate',
        hidden: true,
        meta: {
          title: 'paycenter.activityitemcreate',
          icon: 'dashboard',
        },
      },
      {
        path: 'paymentmanagementlist',
        menu: 'paycenter/paymentmanagementlist',
        component: () => import('@/views/paycenter/paymentmanagementlist'),
        name: 'paymentmanagementlist',
        meta: {
          title: 'paycenter.paymentmanagementlist',
          icon: 'dashboard',
        },
      },
    ],
  },
  {
    path: '/manager',
    component: Layout,
    menu: 'manager/list',
    redirect: '/manager/list',
    // alwaysShow: true, // will always show the root menu
    name: 'manager',
    meta: {
      title: 'manager.manage',
      icon: 'lock',
      roles: ['admin', 'editor'], // you can set roles in root nav
    },
    children: [
      {
        path: 'list',
        menu: 'manager/list',
        component: () => import('@/views/manager/list'),
        name: 'managerlist',
        meta: {
          title: 'manager.list',
          icon: 'dashboard',
          //   affix: true,
        },
      },
      {
        path: 'import',
        menu: 'manager/import',
        component: () => import('@/views/manager/import'),
        name: 'managerimport',
        meta: {
          title: 'manager.import',
          icon: 'dashboard',
        },
      },
      {
        path: 'add',
        menu: 'manager/list',
        component: () => import('@/views/manager/add'),
        name: 'managerdata',
        hidden: true,
        meta: {
          title: 'manager.add',
          icon: 'dashboard',
        },
      },
      {
        path: 'edit/:id',
        menu: 'manager/list',
        component: () => import('@/views/manager/edit'),
        name: 'manageredit',
        hidden: true,
        meta: {
          title: 'manager.edit',
          icon: 'dashboard',
        },
      },
    ],
  },
  {
    path: '/ambassador',
    component: Layout,
    redirect: '/ambassador/list',
    menu: 'ambassador/list',
    // alwaysShow: true, // will always show the root menu
    name: 'ambassador',
    meta: {
      title: 'ambassador.manage',
      icon: 'lock',
      roles: ['admin', 'editor'], // you can set roles in root nav
    },
    children: [
      {
        path: 'list',
        menu: 'ambassador/list',
        component: () => import('@/views/ambassador/list'),
        name: 'ambassadorlist',
        meta: {
          title: 'ambassador.list',
          icon: 'dashboard',
          //   affix: true,
        },
      },
      {
        path: 'honorambassadorlist',
        menu: 'honorambassador/list',
        component: () => import('@/views/honorambassador/list'),
        name: 'honorambassadorlist',
        meta: {
          title: 'honorambassador.list',
          icon: 'dashboard',
          //   affix: true,
        },
      },
      {
        path: 'signcontractimport',
        menu: 'ambassador/signcontractimport',
        component: () => import('@/views/ambassador/signcontractimport'),
        name: 'ambassadorsigncontractimport',
        meta: {
          title: 'ambassador.signcontractimport',
          icon: 'dashboard',
          //   affix: true,
        },
      },
      //   {
      //     path: 'blacklist',
      //     menu: 'ambassador/blacklist',
      //     component: () => import('@/views/ambassador/blacklist'),
      //     name: 'ambassadorblacklist',
      //     meta: {
      //       title: 'ambassador.blacklist',
      //       icon: 'dashboard',
      //       //   affix: true,
      //     },
      //   },
      //   {
      //     path: 'blackimport',
      //     menu: 'ambassador/blackimport',
      //     component: () => import('@/views/ambassador/blackimport'),
      //     name: 'ambassadorblackimportt',
      //     meta: {
      //       title: 'ambassador.blackimport',
      //       icon: 'dashboard',
      //       //   affix: true,
      //     },
      //   },
      {
        path: 'loglist',
        menu: 'ambassador/loglist',
        component: () => import('@/views/ambassador/loglist'),
        name: 'ambassadorloglist',
        meta: {
          title: 'ambassador.loglist',
          icon: 'dashboard',
          //   affix: true,
        },
      },
    ],
  },
  // 预约单管理
  {
    path: '/order',
    component: Layout,
    menu: 'order/list',
    redirect: '/order/list',
    // alwaysShow: true, // will always show the root menu
    name: 'order',
    meta: {
      title: 'order.manage',
      icon: 'lock',
      roles: ['admin', 'editor'], // you can set roles in root nav
    },
    children: [
      {
        path: 'list',
        menu: 'order/list',
        component: () => import('@/views/order/list'),
        name: 'orderlist',
        meta: {
          title: 'order.list',
          icon: 'dashboard',
          //   affix: true,
        },
      },
      {
        path: 'detail/:id',
        menu: 'order/list',
        component: () => import('@/views/order/detail'),
        name: 'orderdata',
        hidden: true,
        meta: {
          title: 'order.detail',
          icon: 'dashboard',
        },
      },
      {
        path: 'import',
        menu: 'order/import',
        component: () => import('@/views/order/import'),
        name: 'orderimport',
        meta: {
          title: 'order.import',
          icon: 'dashboard',
        },
      },
      {
        path: 'sourcelist',
        menu: 'order/sourcelist',
        component: () => import('@/views/order/sourcelist'),
        name: 'ordersourcelist',
        meta: {
          title: 'order.sourcelist',
          icon: 'dashboard',
        },
      },
      {
        path: 'sourceadd',
        menu: 'order/sourcelist',
        component: () => import('@/views/order/sourceadd'),
        name: 'ordersourceadd',
        hidden: true,
        meta: {
          title: 'order.sourceadd',
          icon: 'dashboard',
        },
      },
      {
        path: 'dashboard',
        menu: 'order/dashboard',
        component: () => import('@/views/dashboard/index'),
        name: 'orderdashboard',
        meta: {
          title: 'order.dashboard',
          icon: 'dashboard',
        },
      },
      {
        path: 'bannerlist',
        menu: 'order/bannerlist',
        component: () => import('@/views/order/bannerlist'),
        name: 'bannerlist',
        meta: {
          title: 'order.bannerlist',
          icon: 'dashboard',
          //   affix: true,
        },
      },
    ],
  },
  // 顾问服务中心
  {
    path: '/consultingservicecenter',
    component: Layout,
    menu: 'consultingservicecenter/welfarelist',
    redirect: '/consultingservicecenter/welfarelist',
    // alwaysShow: true, // will always show the root menu
    name: 'consultingservicecenter',
    meta: {
      title: 'consultingservicecenter.manage',
      icon: 'lock',
      roles: ['admin', 'editor'], // you can set roles in root nav
    },
    children: [
      {
        path: 'welfarelist',
        menu: 'consultingservicecenter/welfarelist',
        component: () => import('@/views/consultingservicecenter/welfarelist'),
        name: 'welfarelist',
        meta: {
          title: 'consultingservicecenter.welfarelist',
          icon: 'dashboard',
          //   affix: true,
        },
      },
      {
        path: 'partlist',
        menu: 'consultingservicecenter/partlist',
        component: () => import('@/views/consultingservicecenter/partlist'),
        name: 'partlist',
        meta: {
          title: 'consultingservicecenter.partlist',
          icon: 'dashboard',
        },
      },
      {
        path: 'import',
        menu: 'consultingservicecenter/import',
        component: () => import('@/views/consultingservicecenter/import'),
        name: 'demokitsuitimport',
        meta: {
          title: 'consultingservicecenter.import',
          icon: 'dashboard',
        },
      },
      {
        path: 'suitlist',
        menu: 'consultingservicecenter/suitlist',
        component: () => import('@/views/consultingservicecenter/suitlist'),
        name: 'suitlist',
        meta: {
          title: 'consultingservicecenter.suitlist',
          icon: 'dashboard',
        },
      },
      {
        path: 'resoldqualification',
        menu: 'consultingservicecenter/resoldqualification',
        component: () => import('@/views/consultingservicecenter/resoldqualification'),
        name: 'resoldqualification',
        meta: {
          title: 'consultingservicecenter.resoldqualification',
          icon: 'dashboard',
        },
      },
      {
        path: 'quotaimport',
        menu: 'consultingservicecenter/quotaimport',
        component: () => import('@/views/consultingservicecenter/quotaimport'),
        name: 'quotaimport',
        meta: {
          title: 'consultingservicecenter.quotaimport',
          icon: 'dashboard',
        },
      },
      {
        path: 'resalequotalist',
        menu: 'consultingservicecenter/resalequotalist',
        component: () => import('@/views/consultingservicecenter/resalequotalist'),
        name: 'resalequotalist',
        meta: {
          title: 'consultingservicecenter.resalequotalist',
          icon: 'dashboard',
        },
      },
    ],
  },
  {
    path: '/finacemonth',
    component: Layout,
    menu: 'finacemonth/list',
    redirect: '/finacemonth/list',
    // alwaysShow: true, // will always show the root menu
    name: 'finacemonth',
    meta: {
      title: 'finacemonth.manage',
      icon: 'lock',
      roles: ['admin', 'editor'], // you can set roles in root nav
    },
    children: [
      {
        path: 'list',
        menu: 'finacemonth/list',
        component: () => import('@/views/finacemonth/list'),
        name: 'list',
        meta: {
          title: 'finacemonth.list',
          icon: 'dashboard',
          //   affix: true,
        },
      },
      {
        path: 'finaceweeklist',
        menu: 'finacemonth/finaceweeklist',
        component: () => import('@/views/finacemonth/finaceweeklist'),
        name: 'list',
        meta: {
          title: 'finacemonth.finaceweeklist',
          icon: 'dashboard',
          //   affix: true,
        },
      },
      {
        path: 'advisorsnapshot',
        menu: 'finacemonth/advisorsnapshot',
        component: () => import('@/views/finacemonth/advisorsnapshot'),
        name: 'list',
        meta: {
          title: 'finacemonth.advisorsnapshot',
          icon: 'dashboard',
          //   affix: true,
        },
      },
      {
        path: 'operationlog',
        menu: 'finacemonth/operationlog',
        component: () => import('@/views/finacemonth/operationlog'),
        name: 'list',
        meta: {
          title: 'finacemonth.operationlog',
          icon: 'dashboard',
          //   affix: true,
        },
      },
    ],
  },
  {
    path: '/advisoractivity',
    component: Layout,
    menu: 'advisoractivity/list',
    redirect: '/advisoractivity/personalactivitylist',
    // alwaysShow: true, // will always show the root menu
    name: 'system',
    meta: {
      title: 'advisoractivity.manage',
      icon: 'lock',
      roles: ['admin', 'editor'], // you can set roles in root nav
    },
    children: [
      {
        path: 'advisorpersonalactivitylist',
        menu: 'advisoractivity/personalactivitylist',
        component: () => import('@/views/advisoractivity/personallist'),
        name: 'advisorpersonalactivitylist',
        meta: {
          title: 'advisoractivity.personalactivitylist',
          icon: 'dashboard',
        },
      },
      {
        path: 'advisorteamactivitylist',
        menu: 'advisoractivity/teamactivitylist',
        component: () => import('@/views/advisoractivity/teamlist'),
        name: 'advisorteamactivitylist',
        meta: {
          title: 'advisoractivity.teamactivitylist',
          icon: 'dashboard',
        },
      },
      {
        path: 'advisorattendancelist',
        menu: 'advisoractivity/attendancelist',
        component: () => import('@/views/advisoractivity/attendancelist'),
        name: 'advisorattendancelist',
        meta: {
          title: 'advisoractivity.attendancelist',
          icon: 'dashboard',
        },
      },
      {
        path: 'attendanceimport',
        menu: 'advisoractivity/attendanceimport',
        component: () => import('@/views/advisoractivity/attendanceimport'),
        name: 'advisorattendance',
        meta: {
          title: 'advisoractivity.attendanceimport',
          icon: 'dashboard',
        },
      },
      {
        path: 'attendancecreate',
        menu: 'advisoractivity/attendancelist',
        component: () => import('@/views/advisoractivity/attendancecreate'),
        name: 'advisorattendancecreate',
        hidden: true,
        meta: {
          title: 'advisoractivity.attendancecreate',
          icon: 'dashboard',
        },
      },
      {
        path: 'attendanceedit/:division/:id',
        menu: 'advisoractivity/attendancelist',
        component: () => import('@/views/advisoractivity/attendanceedit'),
        name: 'advisorattendanceedit',
        hidden: true,
        meta: {
          title: 'advisoractivity.attendanceedit',
          icon: 'dashboard',
        },
      },
      {
        path: 'advisorattendanceloglist',
        menu: 'advisoractivity/attendanceloglist',
        component: () => import('@/views/advisoractivity/attendanceloglist'),
        name: 'advisorattendanceloglist',
        meta: {
          title: 'advisoractivity.attendanceloglist',
          icon: 'dashboard',
        },
      },
    ],
  },
  // 历史页面
  {
    path: '/history',
    component: Layout,
    menu: '',
    redirect: '/history',
    name: 'history',
    meta: {
      title: 'history.manage',
      icon: 'lock',
      roles: ['admin', 'editor'], // you can set roles in root nav
    },
    children: [
      {
        path: 'import',
        menu: 'advisor/import',
        component: () => import('@/views/advisor/import'),
        name: 'advisorimport',
        meta: {
          title: 'advisor.import',
          icon: 'dashboard',
        },
      },
      {
        path: 'bindinglist',
        menu: 'advisor/bindinglist',
        component: () => import('@/views/advisorbinding/list'),
        name: 'advisorbindinglist',
        meta: {
          title: 'advisorbinding.list',
          icon: 'dashboard',
        },
      },
      {
        path: 'bindingadd',
        menu: 'advisor/bindinglist',
        component: () => import('@/views/advisorbinding/add'),
        name: 'advisorbindingadddata',
        hidden: true,
        meta: {
          title: 'advisorbinding.add',
          icon: 'dashboard',
        },
      },
      {
        path: 'againbind',
        menu: 'advisor/bindinglist',
        component: () => import('@/views/advisorbinding/againbind'),
        name: 'againbinddata',
        hidden: true,
        meta: {
          title: 'advisorbinding.againbind',
          icon: 'dashboard',
        },
      },
      {
        path: 'bindingloglist',
        menu: 'advisor/bindingloglist',
        component: () => import('@/views/bindinglog/list'),
        name: 'bindingloglist',
        meta: {
          title: 'binginglog.list',
          icon: 'dashboard',
          //   affix: true,
        },
      },
      {
        path: 'rewardpunishmentlist',
        menu: 'advisor/rewardpunishmentlist',
        component: () => import('@/views/advisor/rewardpunishment/list'),
        name: 'advisorrewardpunishmentlist',
        meta: {
          title: 'advisor.rewardpunishmentlist',
          icon: 'dashboard',
        },
      },
      {
        path: 'fteadd',
        menu: 'advisorinduction/fteadd',
        component: () => import('@/views/advisorinduction/fteadd'),
        name: 'advisorinductionfteadd',
        meta: {
          title: 'advisorinduction.fteadd',
          icon: 'dashboard',
        },
      },
      {
        path: 'fteentrycheck',
        menu: 'advisorinduction/fteentrycheck',
        component: () => import('@/views/advisorinduction/fteentrycheck'),
        name: 'advisorinductionfteentrycheck',
        meta: {
          title: 'advisorinduction.fteentrycheck',
          icon: 'dashboard',
        },
      },
      {
        path: 'newtasklist',
        menu: 'advisorinduction/newtasklist',
        component: () => import('@/views/advisorinduction/newtasklist'),
        name: 'advisorinductionnewtasklist',
        meta: {
          title: 'advisorinduction.newtasklist',
          icon: 'dashboard',
        },
      },
      {
        path: 'newpersonmissionloglist',
        menu: 'advisorinduction/newpersonmissionloglist',
        component: () => import('@/views/advisorinduction/newpersonmissionloglist'),
        name: 'advisorinductionnewpersonmissionloglist',
        meta: {
          title: 'advisorinduction.newpersonmissionloglist',
          icon: 'dashboard',
        },
      },
      {
        path: 'teamlist',
        menu: 'organizationalstructure/teamlist',
        component: () => import('@/views/organizationalstructure/teamlist'),
        name: 'organizationalstructureteamlist',
        meta: {
          title: 'organizationalstructure.teamlist',
          icon: 'dashboard',
        },
      },
      {
        path: 'teamcreate',
        menu: 'organizationalstructure/teamcreate',
        component: () => import('@/views/organizationalstructure/teamcreate'),
        name: 'organizationalstructureteamcreate',
        hidden: true,
        meta: {
          title: 'organizationalstructure.teamcreate',
          icon: 'dashboard',
        },
      },
      {
        path: 'studiolist',
        menu: 'organizationalstructure/studiolist',
        component: () => import('@/views/organizationalstructure/studiolist'),
        name: 'organizationalstructurestudiolist',
        meta: {
          title: 'organizationalstructure.studiolist',
          icon: 'dashboard',
        },
      },
      {
        path: 'studiocreate',
        menu: 'organizationalstructure/studiocreate',
        component: () => import('@/views/organizationalstructure/studiocreate'),
        name: 'organizationalstructurestudiocreate',
        hidden: true,
        meta: {
          title: 'organizationalstructure.studiocreate',
          icon: 'dashboard',
        },
      },
      {
        path: 'studioedit/:division/:code',
        menu: 'organizationalstructure/studioedit',
        component: () => import('@/views/organizationalstructure/studioedit'),
        name: 'organizationalstructurestudioedit',
        hidden: true,
        meta: {
          title: 'organizationalstructure.studioedit',
          icon: 'dashboard',
        },
      },
      {
        path: 'classroom',
        menu: 'organizationalstructure/classroom',
        component: () => import('@/views/organizationalstructure/classroomlist'),
        name: 'organizationalstructureclassroomlist',
        meta: {
          title: 'organizationalstructure.classroomlist',
          icon: 'dashboard',
        },
      },
      {
        path: 'classroomcreate',
        menu: 'organizationalstructure/classroomcreate',
        component: () => import('@/views/organizationalstructure/classroomcreate'),
        name: 'organizationalstructureclassroomcreate',
        hidden: true,
        meta: {
          title: 'organizationalstructure.classroomcreate',
          icon: 'dashboard',
        },
      },
      {
        path: 'classroomedit/:division/:code',
        menu: 'organizationalstructure/classroomedit',
        component: () => import('@/views/organizationalstructure/classroomedit'),
        name: 'organizationalstructureclassroomedit',
        hidden: true,
        meta: {
          title: 'organizationalstructure.classroomedit',
          icon: 'dashboard',
        },
      },
      {
        path: 'classroomreservation',
        menu: 'organizationalstructure/classroomreservation',
        component: () => import('@/views/organizationalstructure/classroomreservationlist'),
        name: 'organizationalstructureclassroomreservationlist',
        meta: {
          title: 'organizationalstructure.classroomreservationlist',
          icon: 'dashboard',
        },
      },
    ],
  },
  // // 静态资源管理
  // {
  //   path: '/staticresourcescenter',
  //   component: Layout,
  //   menu: 'staticresources/bannerlist',
  //   redirect: '/staticresources/bannerlist',
  //   // alwaysShow: true, // will always show the root menu
  //   name: 'staticresourcescenter',
  //   meta: {
  //     title: 'staticresourcescenter.manage',
  //     icon: 'lock',
  //     roles: ['admin', 'editor'], // you can set roles in root nav
  //   },
  //   children: [{
  //     path: 'bannerlist',
  //     menu: 'staticresourcescenter/bannerlist',
  //     component: () => import('@/views/staticresources/bannerlist'),
  //     name: 'bannerlist',
  //     meta: {
  //       title: 'staticresourcescenter.bannerlist',
  //       icon: 'dashboard',
  //       //   affix: true,
  //     },
  //   },
  //   ],
  // },
  {
    path: '*',
    menu: '',
    component: () => import('@/views/error-page/401'),
    name: 'Page401',
    hidden: true,
    meta: {
      title: 'exceptionpage.fourzeroone',
      noCache: true,
    },
  },
  //   tableRouter,
  // componentsRouter,
  // {
  //   path: '/example',
  //   component: Layout,
  //   redirect: '/example/list',
  //   name: 'Example',
  //   meta: {
  //     title: 'Example',
  //     icon: 'el-icon-s-help',
  //   },
  //   children: [
  //     {
  //       path: 'create',
  //       component: () => import('@/views/example/create'),
  //       name: 'CreateArticle',
  //       meta: { title: 'Create Article', icon: 'edit' },
  //     },
  //     {
  //       path: 'edit/:id(\\d+)',
  //       component: () => import('@/views/example/edit'),
  //       name: 'EditArticle',
  //       meta: { title: 'Edit Article', noCache: true, activeMenu: '/example/list' },
  //       hidden: true,
  //     },
  //     {
  //       path: 'list',
  //       component: () => import('@/views/example/list'),
  //       name: 'ArticleList',
  //       meta: { title: 'Article List', icon: 'list' },
  //     },
  //   ],
  // },
];

export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true,
  },
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index'),
      },
    ],
  },

  {
    path: '/error',
    component: Layout,
    redirect: 'noRedirect',
    name: 'ErrorPages',
    hidden: true,
    meta: {
      title: 'exceptionpage.index',
      icon: '404',
    },
    children: [
      //     {
      //     path: '401',
      //     component: () => import('@/views/error-page/401'),
      //     name: 'Page401',
      //     meta: {
      //       title: 'exceptionpage.fourzeroone',
      //       noCache: true,
      //     },
      //   },
      {
        path: '404',
        component: () => import('@/views/error-page/404'),
        name: 'Page404',
        meta: {
          title: 'exceptionpage.fourzerofour',
          noCache: true,
        },
      },
    ],
  },

  //   {
  //     path: '/dashboard',
  //     component: Layout,
  //     redirect: '/dashboard',
  //     children: [
  //       {
  //         path: 'dashboard',
  //         component: () => import('@/views/dashboard/index'),
  //         name: 'dashboard',
  //         meta: { title: 'dashboard', icon: 'dashboard', affix: false },
  //       },
  //     ],
  //   },
  // {
  //   path: '/excel',
  //   component: Layout,
  //   redirect: '/excel/export-excel',
  //   name: 'Excel',
  //   meta: {
  //     title: 'excel.manage',
  //     icon: 'excel',
  //   },
  //   children: [
  //     // {
  //     //   path: 'export-excel',
  //     //   component: () => import('@/views/excel/export-excel'),
  //     //   name: 'ExportExcel',
  //     //   meta: { title: 'Export Excel' }
  //     // },
  //     // {
  //     //   path: 'export-selected-excel',
  //     //   component: () => import('@/views/excel/select-excel'),
  //     //   name: 'SelectExcel',
  //     //   meta: { title: 'Export Selected' }
  //     // },
  //     // {
  //     //   path: 'export-merge-header',
  //     //   component: () => import('@/views/excel/merge-header'),
  //     //   name: 'MergeHeader',
  //     //   meta: { title: 'Merge Header' }
  //     // },
  //     {
  //       path: 'upload-excel',
  //       component: () => import('@/views/excel/upload-excel'),
  //       name: 'UploadExcel',
  //       meta: { title: 'excel.upload' },
  //     },
  //   ],
  // },
];

const createRouter = () =>
  new Router({
    scrollBehavior: () => ({
      y: 0,
    }),
    routes: constantRoutes,
  });

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

router.beforeEach((to, from, next) => {
  if (getAccessToken() && getUserInfo() !== null) {
    if (to.path === '/login') {
      next({
        path: '/',
      });
    } else if (store.getters.permission_routes === undefined) {
      const userInfo = getUserInfo();
      store.dispatch('permission/generateRoutes', userInfo.isAdmin ? 'admin' : userInfo.pages).then(accessRoutes => {
        router.addRoutes(accessRoutes);
      });
      store.dispatch('permission/generatePermissions', userInfo.isAdmin ? 'admin' : userInfo.operations).then(() => { });
    }
    next();
  } else if (whiteList.indexOf(to.path) !== -1) {
    next();
  } else {
    removeAccessToken();
    removeUserInfo();
    store.dispatch('user/getToken', this.form).then(res => {
      if (!res.success) {
        const url = `${window.location.protocol}//${window.location.host}/login`;
        // eslint-disable-next-line no-nested-ternary
        // const hrefUrl = process.env.NODE_ENV === 'development' ? 'https://www.baidu.com' :
        //   (process.env.NODE_ENV === 'staging' ? 'https://preadmin.vorwerkchina.com/login' : url);
        // eslint-disable-next-line no-nested-ternary
        // const hrefUrl = process.env.NODE_ENV === 'development' ? 'https://qaadmin.vorwerkchina.com/' :
        //   (process.env.NODE_ENV === 'staging' ? 'https://qaadmin.vorwerkchina.com/login' : url);
        const hrefUrl = process.env.NODE_ENV === 'development' ? 'https://qaadmin.vorwerkchina.com/' : url;

        window.location.href = hrefUrl;
      } else {
        const userInfo = getUserInfo();
        store.dispatch('permission/generatePermissions', userInfo.isAdmin ? 'admin' : userInfo.operations).then(() => { });
        store.dispatch('permission/generateRoutes', userInfo.isAdmin ? 'admin' : userInfo.pages).then(accessRoutes => {
          router.addRoutes(accessRoutes);
          next({
            path: to.path,
          });
        });
      }
    });
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js